import { DateTime } from "luxon";
import { date } from "@/components/mixins/date";
export const DEFAULT_COLOR = "#FFF";
export const DEFAULT_LABEL = "No Label";

export const MAP_STATUSES = {
  UNKNOWN: "UNKNOWN",
  READY: "READY",
  EXE: "EXE",
  FAIL: "FAIL",
  POWER_OFF: "POWER_OFF",
  HANDLING: "HANDLING",
  DISCONNECTED: "DISCONNECTED"
};

export const STATUSES = [
  MAP_STATUSES.FAIL,
  MAP_STATUSES.READY,
  MAP_STATUSES.EXE,
  MAP_STATUSES.POWER_OFF,
  MAP_STATUSES.HANDLING
];

export const getColor = status =>
  ({
    FAIL: "#FC5C65", // red
    READY: "#FED330", // yellow
    EXE: "#26DE81", // green
    SETUP: "#FFF", // white
    DISCONNECTED: "#FFF", // white
    POWER_OFF: "#8A8A8A", // grey,
    HANDLING: "#dded9c", // light green
    UNKNOWN: "#FFF"
  }[status.toUpperCase()] || DEFAULT_COLOR);

export const getLabel = status =>
  ({
    FAIL: "Alarm",
    READY: "Idle",
    EXE: "Work",
    SETUP: "Idle",
    POWER_OFF: "Not Ready",
    DISCONNECTED: "Disconnected",
    HANDLING: "Handling",
    UNKNOWN: ""
  }[status.toUpperCase()] || DEFAULT_LABEL);

const mapStatusColor = {
  exe: "green",
  ready: "yellow",
  power_off: "grey",
  fail: "red",
  setup: "yellow",
  handling: "light_green",
  disconnected: "black",
  undefined: "black",
  unknown: "black"
};

export const isValidStatusData = data => {
  const status = (data && (data.Status || data.v)) || data || "";
  const key = `${status}`.toLowerCase();
  return key in mapStatusColor;
};

export const wrapStatus = status => {
  const map = mapStatusColor;
  const key = `${status}`.toLowerCase();
  let result = "black";

  if (key in map) {
    result = map[key];
  }

  return result;
};

export const dataToStatus = data => {
  const raw = data && (data.Status || data.v);
  const timestamp = data && (data.LastUpdate || data.ts);
  const color = wrapStatus(raw);

  return { raw, color, timestamp };
};

export const wrapColorStatus = color => {
  return {
    green: "EXE",
    light_green: "HANDLING",
    yellow: "READY",
    grey: "POWER_OFF",
    red: "FAIL",
    black: "DISCONNECTED",
    undefined: "N.A."
  }[color];
};

export const dateFromTimeSelector = (selector, from, zone) => {
  /*
    Es. from =  '2020-07-14' and .startOf('day') set:
    - with ZONE 'local' e.g. 2020-07-13T22:00:00.000Z
    - with ZONE 'utc' e.g. 2020-07-14T00:00:00.000Z
  */

  const dt = DateTime.fromJSDate(from ? new Date(from) : new Date(), {
    zone: zone ? zone : "local"
  }).startOf("day");

  if (selector === "week") {
    return dt.minus({ days: 6 }).toJSDate().toISOString();
  }
  if (selector === "month") {
    return dt.minus({ months: 1 }).toJSDate().toISOString();
  }
  if (selector === "year") {
    return dt.minus({ years: 1 }).toJSDate().toISOString();
  }
  // With Selector 'day'  or null return start day of param "from"
  return dt.toJSDate().toISOString();
};

export const todayAtMidnight = () => date.methods.objDateTodayEndOf().toISOString();

export const todayAtEndDay = () => date.methods.objDateTodayStartOf().toISOString();

export const todayAtNow = () => date.methods.objDateToday().toISOString();
